export const slideLayouts = [
    {
        'type': 'row',
        'children': [
            {
                'id': 1
            }
        ]
    },
    {
        'type': 'row',
        'children': [
            {
                'id': 1
            },
            {
                'id': 2
            }
        ]
    },
    {
        'type': 'row',
        'children': [
            {
                'id': 1
            },
            {
                'id': 2
            },
            {
                'id': 3
            }
        ]
    },
    {
        'type': 'row',
        'children': [
            {
                'id': 1,
                'flex-grow': 2
            },
            {
                'id': 2
            }
        ]
    },
    {
        'type': 'row',
        'children': [
            {
                'id': 1
            },
            {
                'id': 2,
                'flex-grow': 2
            }
        ]
    },
    {
        'type': 'row',
        'children': [
            {
                'id': 1
            },
            {
                'id': 2
            },
            {
                'id': 3
            },
            {
                'id': 4
            }
        ]
    },
    {
        'type': 'row',
        'children': [
            {
                'id': 1
            },
            {
                'id': 2
            },
            {
                'id': 3
            },
            {
                'id': 4
            },
            {
                'id': 5
            }
        ]
    },
    {
        'type': 'row',
        'children': [
            {
                'id': 1
            },
            {
                'id': 2
            },
            {
                'id': 3
            },
            {
                'id': 4
            },
            {
                'id': 5
            },
            {
                'id': 6
            }
        ]
    },
    {
        'type': 'row',
        'children': [
            {
                'id': 1
            },
            {
                'id': 2
            },
            {
                'id': 3
            },
            {
                'id': 4
            },
            {
                'id': 5
            },
            {
                'id': 6
            },
            {
                'id': 7
            }
        ]
    },
    {
        'type': 'row',
        'children': [
            {
                'id': 1
            },
            {
                'id': 2
            },
            {
                'id': 3
            },
            {
                'id': 4
            },
            {
                'id': 5
            },
            {
                'id': 6
            },
            {
                'id': 7
            },
            {
                'id': 8
            }
        ]
    },
    {
        'type': 'row',
        'children': [
            {
                'id': 1
            },
            {
                'id': 2
            },
            {
                'id': 3
            },
            {
                'id': 4
            },
            {
                'id': 5
            },
            {
                'id': 6
            },
            {
                'id': 7
            },
            {
                'id': 8
            },
            {
                'id': 9
            }
        ]
    },
    {
        'type': 'row',
        'children': [
            {
                'id': 1
            },
            {
                'id': 2
            },
            {
                'id': 3
            },
            {
                'id': 4
            },
            {
                'id': 5
            },
            {
                'id': 6
            },
            {
                'id': 7
            },
            {
                'id': 8
            },
            {
                'id': 9
            },
            {
                'id': 10
            }
        ]
    }
]
